var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCopiedLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-915 -133)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 13",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(915 133)",
    style: {
      fill: "#0222ba"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "done_black_24dp (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 213",
    d: "M0 0h15.527v15.527H0z",
    style: {
      fill: "none"
    },
    transform: "translate(918.236 136.236)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 214",
    d: "M7.023 12.458 4.306 9.741l-.906.906 3.623 3.623 7.764-7.764-.906-.906z",
    transform: "translate(917.036 134.259)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopiedLight);
export default __webpack_public_path__ + "static/media/icon-copied-light.2be34967e9980895924d3cc555ea79a9.svg";
export { ForwardRef as ReactComponent };